import(/* webpackMode: "eager" */ "/build/src/app/error.tsx")